<template>

    <div id="manifest">

        <section class="manifesto">
            <div class="manifesto__overlay"></div>
            <div class="manifesto__container">
                <div class="manifesto__content">
                    <h2 class="manifesto__title">
                        {{ 'manifesto' | staticTitle }}
                    </h2>
                    <vue-marked>{{ 'manifesto' | staticContent }}</vue-marked>
                    <div class="manifesto__highlight">
                        <vue-marked>{{ 'manifesto' | staticContentAlt }}</vue-marked>
                    </div>
                </div>
            </div>
        </section>

        <div class="hero__corner-logo">
            <img :src="'logo2.webp'|assetsImg"  alt="Bridgerocks World">
        </div>
    
        <section class="statements">
            <div class="statements__overlay"></div>
            <div class="statements__container">
                <article class="statement">
                    <div class="statement__icon">
                        <i class="fa-solid fa-flag"></i>
                    </div>
                    <vue-marked>{{ 'manifesto_mission' | staticContent }}</vue-marked>
                </article>
                <article class="statement">
                    <div class="statement__icon">
                        <i class="fa-solid fa-rocket"></i>
                    </div>
                    <vue-marked>{{ 'manifesto_vision' | staticContent }}</vue-marked>
                </article>
            </div>
        </section>

        <section class="manifesto compass">
            <div class="manifesto__overlay"></div>
            <div class="manifesto__container">
                <div class="manifesto__content">
                    <h2 class="manifesto__title">
                        {{ 'manifesto_our_compass' | staticTitle }}
                    </h2>
                    <vue-marked>{{ 'manifesto_our_compass' | staticContent }}</vue-marked>
                    <div class="manifesto__highlight">
                        <vue-marked>{{ 'manifesto_our_compass' | staticContentAlt }}</vue-marked>
                    </div>
                </div>
            </div>
        </section>

    </div>


</template>

<script>
/* eslint-disable */

export default {
    name: 'Manifesto',

    mounted() {
        if (window.mainUI && typeof window.mainUI === 'function')
            setTimeout(window.mainUI, 150);
    }
};
</script>